import Analytics from "analytics";
import amplitudePlugin from "./amplitudePlugin";

export * from "./analyticsHooks";

export type AnalyticsApp = "akina-care" | "akina-session" | "akina-portal";


export const configureAnalyticsService = (
  silent: boolean,
  params: {
    amplitudeApiKey: string;
    app: AnalyticsApp;
  },
) => {
  const analytics = Analytics({
    app: "akina",
    plugins: [
      amplitudePlugin({
        apiKey: params.amplitudeApiKey,
        app: params.app,
      }),
    ],
  });

  const analyticsService = {
    identifyUser: (user: { id: string; firstName?: string; lastName?: string; email?: string }) => {
      if (silent) return;
      analytics.identify(user.id, {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
      });
    },
    track: (eventName: string, eventProperties: unknown) => {
      if (silent) return;
      analytics.track(eventName, eventProperties);
    },
    trackAsync: async (eventName: string, eventProperties: unknown) => {
      if (silent) return Promise.resolve();
      return await analytics.track(eventName, eventProperties);
    },
    page: (properties: { path: string }) => {
      if (silent) return;
      analytics.page(properties);
    },
  };

  return analyticsService;
};
